import styled from 'styled-components';
import { scrollbar } from 'modules/scrollbar';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
export const TextAreaContainer = styled.div `
  position: relative;
  width: 100%;
  display: flex;
  gap: ${themeGet('spacing.md')};
`;
export const TextAreaFocusLine = styled.div `
  width: ${pxToRem(2)};
  height: ${pxToRem(24)};
  margin-top: ${pxToRem(4)};
  background-color: ${themeGet('colors.blue.500')};
  transition: opacity 175ms ease-in-out;
  opacity: ${(props) => (props.$hasFocus ? 1 : 0)};
`;
export const StyledTextArea = styled.textarea `
  ${scrollbar()};

  width: 100%;
  padding: 0;
  padding-top: ${pxToRem(5)};
  resize: none;
  border: none;
  outline: none;
  color: ${themeGet('colors.text.300')};
  font-size: ${themeGet('fontSize.medium')};
  line-height: ${themeGet('lineHeight.default')};
  background-color: ${themeGet('colors.gray.0')};
`;
